import * as types from './types'

export default {
  [types.GET_AVAILABLE_COUNTRIES](state) {
    return Object.keys(state.pricing[state.selectedProduct])
  }
}
